// src/pages/Settings.jsx
import React, { Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Appfooter from "../components/Appfooter";
import { useTranslation } from "react-i18next";
import { useAPI } from "../context/ApiContext";

const Settings = () => {
  const { t } = useTranslation();
  const api = useAPI();

  return (
    <Fragment>
      <Header />
      <Leftnav />

      <div className="main-content bg-lightblue theme-dark-bg right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                <div className="card-body p-lg-5 p-4 w-100 border-0">
                  <h4 className="mb-4 font-xxl fw-700 mont-font mb-lg-5 mb-4 font-md-xs">
                    {t("Settings1") || "設定"}
                  </h4>

                  <div className="nav-caption fw-600 font-xsss text-grey-500 mb-2">
                    {t("Settings2") || "基本"}
                  </div>
                  <ul className="list-inline mb-4">
                    {api.isAuthenticated && (
                      <li className="list-inline-item d-block border-bottom me-0">
                        <Link to="/account" className="pt-2 pb-2 d-flex align-items-center">
                          <i className="btn-round-md bg-primary-gradiant text-white feather-user font-md me-3"></i>
                          <h4 className="fw-600 font-xsss mb-0 mt-0">{t("Settings3") || "プロフィール"}</h4>
                          <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                        </Link>
                      </li>
                    )}
                    <li className="list-inline-item d-block border-bottom me-0">
                      <Link to="/howto" className="pt-2 pb-2 d-flex align-items-center">
                        <i className="btn-round-md bg-primary-gradiant text-white feather-chevrons-right font-md me-3"></i>
                        <h4 className="fw-600 font-xsss mb-0 mt-0">{t("Settings4") || "使い方"}</h4>
                        <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item d-block border-bottom me-0">
                      <Link to="/languagesetting" className="pt-2 pb-2 d-flex align-items-center">
                        <i className="btn-round-md bg-primary-gradiant text-white feather-globe font-md me-3"></i>
                        <h4 className="fw-600 font-xsss mb-0 mt-0">{t("Settings5") || "言語設定"}</h4>
                        <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item d-block border-bottom me-0">
                      <Link to="/sensitivesetting" className="pt-2 pb-2 d-flex align-items-center">
                        <i className="btn-round-md bg-primary-gradiant text-white feather-eye-off font-md me-3"></i>
                        <h4 className="fw-600 font-xsss mb-0 mt-0">{t("Settings101") || "18歳以上向けまたはセンシティブ投稿の閲覧設定"}</h4>
                        <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item d-block border-bottom me-0">
                      <Link to="/notificationsetting" className="pt-2 pb-2 d-flex align-items-center">
                        <i className="btn-round-md bg-primary-gradiant text-white feather-bell font-md me-3"></i>
                        <h4 className="fw-600 font-xsss mb-0 mt-0">{t("Settings13") || "通知設定"}</h4>
                        <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                      </Link>
                    </li>
                  </ul>

                  <div className="nav-caption fw-600 font-xsss text-grey-500 mb-2">
                    {t("Settings6") || "その他"}
                  </div>
                  <ul className="list-inline mb-4">
                    <li className="list-inline-item d-block border-bottom me-0">
                      <Link to="/adapplication" className="pt-2 pb-2 d-flex align-items-center">
                        <i className="btn-round-md bg-blue-gradiant text-white feather-radio font-md me-3"></i>
                        <h4 className="fw-600 font-xsss mb-0 mt-0">{t("Settings7") || "広告申し込み"}</h4>
                        <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item d-block border-bottom me-0">
                      <Link to="/Notations-SCTA" className="pt-2 pb-2 d-flex align-items-center">
                        <i className="btn-round-md bg-blue-gradiant text-white feather-feather font-md me-3"></i>
                        <h4 className="fw-600 font-xsss mb-0 mt-0">{t("Settings12") || "特商法表記"}</h4>
                        <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item d-block border-bottom me-0">
                    <Link to="/terms" className="pt-2 pb-2 d-flex align-items-center">
                      <i className="btn-round-md bg-blue-gradiant text-white feather-file-text font-md me-3"></i>
                      <h4 className="fw-600 font-xsss mb-0 mt-0">{t("legal:links.terms")}</h4>
                      <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                    </Link>
                  </li>
                  <li className="list-inline-item d-block border-bottom me-0">
                    <Link to="/privacy" className="pt-2 pb-2 d-flex align-items-center">
                      <i className="btn-round-md bg-blue-gradiant text-white feather-shield font-md me-3"></i>
                      <h4 className="fw-600 font-xsss mb-0 mt-0">{t("legal:links.privacy")}</h4>
                      <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                    </Link>
                  </li>
                  <li className="list-inline-item d-block border-bottom me-0">
                    <Link to="/guidelines" className="pt-2 pb-2 d-flex align-items-center">
                      <i className="btn-round-md bg-blue-gradiant text-white feather-sliders font-md me-3"></i>
                      <h4 className="fw-600 font-xsss mb-0 mt-0">{t("legal:links.guidelines")}</h4>
                      <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                    </Link>
                  </li>
                  <li className="list-inline-item d-block border-bottom me-0">
                    <Link to="/contact" className="pt-2 pb-2 d-flex align-items-center">
                      <i className="btn-round-md bg-blue-gradiant text-white feather-mail font-md me-3"></i>
                      <h4 className="fw-600 font-xsss mb-0 mt-0">{t("legal:links.contact")}</h4>
                      <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                    </Link>
                  </li>
                  </ul>

                  {api.isAuthenticated && (
                    <>
                      <div className="nav-caption fw-600 font-xsss text-grey-500 mb-2">
                        {t("Settings9") || "アカウント"}
                      </div>
                      <ul className="list-inline">
                        <li className="list-inline-item d-block me-0 border-bottom">
                          <Link to="/logout" className="pt-2 pb-2 d-flex align-items-center">
                            <i className="btn-round-md bg-red-gradiant text-white feather-log-out font-md me-3"></i>
                            <h4 className="fw-600 font-xsss mb-0 mt-0">{t("Settings10") || "ログアウト"}</h4>
                            <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                          </Link>
                        </li>
                        <li className="list-inline-item d-block me-0 border-bottom">
                          <Link to="/deleteaccount" className="pt-2 pb-2 d-flex align-items-center">
                            <i className="btn-round-md bg-red-gradiant text-white feather-lock font-md me-3"></i>
                            <h4 className="fw-600 font-xsss mb-0 mt-0">{t("Settings11") || "アカウント削除"}</h4>
                            <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3"></i>
                          </Link>
                        </li>
                      </ul>
                    </>
                  )}
                </div>
              </div>

              <div className="p-4 mb-3"></div>
            </div>
          </div>
        </div>
      </div>

      <Appfooter />
    </Fragment>
  );
};

export default Settings;
